import { RadioGroup } from "@headlessui/react";
import classNames from "classnames";
import { Typography } from "@circle-react-uikit/Typography";

export interface OptionProps {
  children: React.ReactNode;
  className?: string;
  value: "light" | "dark";
}

export const Option = ({
  children,
  className,
  value,
  ...rest
}: OptionProps) => (
  <RadioGroup.Option
    key={value}
    value={value}
    className={({ checked }) =>
      classNames(
        "flex flex-1 cursor-pointer select-none items-center justify-center rounded-lg border p-3",
        {
          "bg-selector-active border-secondary shadow": checked,
          "bg-primary border-selector-inactive": !checked,
        },
      )
    }
  >
    {({ checked }) => (
      <Typography.LabelSm>
        <RadioGroup.Description
          as="label"
          className={classNames(
            "mb-0 flex items-center gap-3",
            {
              "text-selector-active": checked,
              "text-default": !checked,
            },
            className,
          )}
          {...rest}
        >
          {children}
        </RadioGroup.Description>
      </Typography.LabelSm>
    )}
  </RadioGroup.Option>
);
